import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useBindDispatch } from '../../hooks'
import { Container, Row, Col, CardVillage, Card } from '../../components'
import './village.scss'
import { getConnectUser } from 'helpers'

export const VillageSelection = ({ veVillages }) => {
    veVillages = veVillages || getConnectUser().veVillages || []
    const navigate = useNavigate()
    const { search } = useLocation()
    const { t } = useTranslation()
    const { openVillagePageData } = useSelector(
        (state) => state.openVillagePage
    )
    const { url } = useSelector((state) => state.villageSelectionInfo)
    const { totalClientObj } = useSelector(
        (state) => state.multipleVillagesCount
    )

    const clientList = useSelector((state) => state.villageClientList || {})

    const previousClientList = useSelector(
        (state) => state.villagePreviousClientList || {}
    )

    const {
        openVillagePageHandler,
        clearVillageSelectionInfoHandler,
        handleMultipleVillagesCountHandler
    } = useBindDispatch()

    const isClientDoneLoading = useMemo(() => {
        if (Object.values(clientList).length < 1) return false
        return Object.values(clientList).every((client) => !client.loading)
    }, [clientList])

    const isPrevClientDoneLoading = useMemo(() => {
        if (Object.values(previousClientList).length < 1) return false
        return Object.values(previousClientList).every(
            (client) => !client.loading
        )
    }, [previousClientList])

    const fromTab = parseInt((search || '').split('from_tab=')[1])

    useEffect(() => {
        handleMultipleVillagesCountHandler(
            veVillages?.map((village) => village.sf_id) || []
        )
        return () => {
            clearVillageSelectionInfoHandler()
        }
    }, [isClientDoneLoading, isPrevClientDoneLoading])

    const processedTotalClientObj = useMemo(() => {
        const allVilla = Object.keys(totalClientObj)
        const obj = { ...totalClientObj }
        const villages = veVillages?.map((village) => village.sf_id) || []
        if (allVilla.length < 1) return {}
        villages.forEach((key) => {
            if (!allVilla.includes(key)) {
                obj[key] = {
                    NbCurrentClients: 0,
                    NbPrevClients: 0
                }
            }
        })

        return obj
    }, [totalClientObj])

    const villageSelectionHandler = (sfId) => {
        const fromTabValue = fromTab ? `?from_tab=${fromTab}` : ''
        if (
            openVillagePageData &&
            Object.keys(openVillagePageData).length < 1
        ) {
            const updatedVillageData = {
                ...openVillagePageData,
                villageId: sfId
            }
            openVillagePageHandler(updatedVillageData)
        }

        if (url) {
            if (typeof url === 'function') {
                return navigate(url(sfId))
            }
            return navigate(`${url}${sfId}${fromTabValue}`)
        }
        navigate(`/village/${sfId}${fromTabValue}`)
    }

    return (
        <div className="dual-village page-wrapper">
            <Container>
                <Row className="dual-village--header-parent">
                    <Col md={12}>
                        <h2 className="header-welcome dual-village--header">
                            {t('village.chooseVillage')}
                        </h2>
                    </Col>
                </Row>
                <Row>
                    {veVillages?.map(({ name, sf_id: sfID }, idx) => (
                        <Col
                            col={12}
                            md={6}
                            className="dual-village--section"
                            key={idx}
                            data-testid="village-card"
                        >
                            <Card
                                onClick={() => villageSelectionHandler(sfID)}
                                className="village-card"
                                data-testid="village-card-selection"
                            >
                                <CardVillage
                                    clientNumbers={{
                                        potentialClients:
                                            isPrevClientDoneLoading ||
                                            processedTotalClientObj[sfID]
                                                ?.NbPrevClients >= 0
                                                ? processedTotalClientObj[sfID]
                                                      ?.NbPrevClients || 0
                                                : '',
                                        clients:
                                            isClientDoneLoading ||
                                            processedTotalClientObj[sfID]
                                                ?.NbCurrentClients >= 0
                                                ? processedTotalClientObj[sfID]
                                                      ?.NbCurrentClients || 0
                                                : ''
                                    }}
                                >
                                    {name}
                                </CardVillage>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    )
}

VillageSelection.propTypes = {
    veVillages: PropTypes.array
}
